import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Warning = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.28132 20H19.7202C20.5807 20 21.3511 19.55 21.7413 18.82C22.1216 18.12 22.0815 17.3 21.6413 16.63L13.9168 5.01C13.4966 4.38 12.7862 4 12.0058 4C11.2253 4 10.5149 4.38 10.0947 5.01L2.37022 16.63C1.91996 17.3 1.87994 18.12 2.26016 18.82C2.66039 19.55 3.43083 20 4.28132 20ZM11.1252 5.69C11.3154 5.4 11.6455 5.23 12.0058 5.23C12.366 5.23 12.6961 5.4 12.8863 5.69L20.6107 17.31C20.8108 17.6 20.8208 17.94 20.6607 18.24C20.4806 18.57 20.1304 18.77 19.7302 18.77H4.27131C3.87108 18.77 3.52088 18.57 3.34078 18.24C3.18069 17.94 3.2007 17.6 3.39081 17.31L11.1252 5.69ZM12.0052 14.6C11.6652 14.6 11.3852 14.32 11.3852 13.98V8.45C11.3852 8.11 11.6652 7.83 12.0052 7.83C12.3452 7.83 12.6252 8.11 12.6252 8.45V13.99C12.6252 14.33 12.3452 14.61 12.0052 14.61V14.6ZM12.0057 17.69C12.5197 17.69 12.9363 17.2736 12.9363 16.76C12.9363 16.2464 12.5197 15.83 12.0057 15.83C11.4918 15.83 11.0752 16.2464 11.0752 16.76C11.0752 17.2736 11.4918 17.69 12.0057 17.69Z"
    />
  </svg>
)

export default withDefaultStyles(Warning)
